import type { ReactNode } from "react";
import { toFormattedFloat, toFormattedInteger } from "src/utils";

type CalculationDetailsRowProp = {
  label: string;
  amount: string;
  badge?: ReactNode;
  hasDollar?: boolean;
  precision?: number;
};

export default ({
  label,
  badge,
  hasDollar,
  amount,
  precision,
}: CalculationDetailsRowProp) => {
  return (
    <div className="flex justify-between gap-4 py-1 text-[#687083]">
      <div className="flex flex-wrap gap-4">{label}</div>
      <div className="flex flex-row gap-4 text-nowrap">
        {badge}
        {hasDollar && "$"}{" "}
        {precision
          ? toFormattedFloat(amount, precision)
          : toFormattedInteger(amount)}
      </div>
    </div>
  );
};
